import React, { useCallback, useState } from 'react'

import { H5, Text, TinyText } from '../texts'
import { Styled } from './styled'

const HotKey = ({ hotKey, picture }) => (
  <Styled.HotKeyContainer picture={picture}>
    <H5 color="turquoise">{hotKey}</H5>
  </Styled.HotKeyContainer>
)

const BigTooltip = ({ picture, text, hotKey, description }) => (
  <>
    {picture && <img src={picture} alt="tooltip" />}
    <Styled.TextWithHotKey description={description} picture={picture}>
      <H5 textAlign="center">{text}</H5>
      {hotKey && <HotKey hotKey={hotKey} />}
    </Styled.TextWithHotKey>
    {description && (
      <Styled.DescriptionContainer>
        <TinyText color="gray">{description}</TinyText>
      </Styled.DescriptionContainer>
    )}
  </>
)

const SmallTooltip = ({ text, hotKey, description }) => (
  <>
    <Styled.Header description={description} hotKey={hotKey}>
      <Text color='mainFont' fontSize={14} fontFamily='Medium'>{text}</Text>
      {hotKey && (
        <Styled.Hotkey description={description}>
          <Text color='white' fontSize={14}>{hotKey}</Text>
        </Styled.Hotkey>
      )}
    </Styled.Header>
    {description && (
      <Styled.Description>
        <Text color='gray' fontSize={12}>{description}</Text>
      </Styled.Description>
    )}
  </>
)

export const Tooltip = ({
  id,
  position,
  text,
  speed,
  size,
  targetTop,
  targetBottom,
  targetLeft,
  targetRight,
  targetWidth,
  targetHeight,
  hotKey,
  tooltipWidth,
  wordBreakAll,
  picture,
  description,
  tooltipOverflow,
  isTranslucent,
}) => {
  const [dimensions, setDimensions] = useState(null);
  const toolTipCallbackRef = useCallback(domNode => {
    if (domNode && !dimensions) {
      setDimensions(domNode.getBoundingClientRect());
    }
  });
  const containerWidth = dimensions && dimensions.width;
  const containerHeight = dimensions && dimensions.height;

  return (
    <Styled.TooltipContainer
      id={id}
      position={position}
      targetTop={targetTop}
      targetBottom={targetBottom}
      targetLeft={targetLeft}
      targetRight={targetRight}
      targetWidth={targetWidth}
      targetHeight={targetHeight}
      width={containerWidth}
      height={containerHeight}
      speed={speed}
      hotKey={hotKey}
      tooltipWidth={tooltipWidth}
      picture={picture}
      size={size}
      isTranslucent={isTranslucent}
      ref={toolTipCallbackRef}
    >
      {hotKey || description || picture
        ? size === 'small'
          ? <SmallTooltip text={text} hotKey={hotKey} description={description} />
          : <BigTooltip picture={picture} text={text} hotKey={hotKey} description={description} />
        : <TinyText
            textAlign='center'
            wordBreak={wordBreakAll && 'keep-all'}
            nowrap={!wordBreakAll}
            overflow={tooltipOverflow}
          >
            {text}
          </TinyText>
      }
    </Styled.TooltipContainer >
  )
}
